import { IBodyInfo } from '../../../services/IBodyInfo';
import { BodyFormModel } from './BodyFormModel';

export { toBodyInfo };

const toBodyInfo = (source: BodyFormModel): IBodyInfo => {
	return {
		name: source.name.value ?? '',
		type: source.type.value,
	};
};
